"use strict";
/* eslint-disable no-console */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Log = exports.LogLevel = void 0;
function addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["None"] = 0] = "None";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Info"] = 3] = "Info";
    LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
class Log {
    static info(...args) {
        if (this.level >= LogLevel.Info) {
            console.info(...addTag(args));
        }
    }
    static debug(...args) {
        if (this.level >= LogLevel.Debug) {
            console.debug(...addTag(args));
        }
    }
    static warn(...args) {
        if (this.level >= LogLevel.Warn) {
            console.warn(...addTag(args));
        }
    }
    static error(...args) {
        if (this.level >= LogLevel.Error) {
            console.error(...addTag(args));
        }
    }
}
exports.Log = Log;
Log.level = LogLevel.Error;
